import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Layout } from '@eventbrite/eds-layout';
import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eventbrite/site-structure';

export default class Page extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
        children: PropTypes.node,

        isLoading: PropTypes.bool,
    };

    render() {
        const {
            env,
            request,
            user = {},
            location: { pathname: currentPath },
            footerLinks,
            children,
            isLoading,
            featureFlags,
        } = this.props;

        let pageTitle;

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                footerLinks={footerLinks}
                isLoading={isLoading}
                fullScreenMain={true}
                pageTitle={pageTitle}
                featureFlags={featureFlags}
            >
                <Layout maxWidth="large" hasHorizontalGutters={true}>
                    {children}
                </Layout>
            </SiteStructure>
        );
    }
}
